module.exports = __webpack_public_path__ + "media/1alB-o-ros.eddd9765.mp3";